"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _customPropTypes = require("@paprika/helpers/lib/customPropTypes");

var _Textarea = _interopRequireDefault(require("./Textarea.styles"));

var propTypes = {
  /** Descriptive a11y text for assistive technologies. By default, text from children node will be used. */
  a11yText: _propTypes["default"].string,

  /** Indicate if the textarea is expandable */
  canExpand: _propTypes["default"].bool,

  /** Sets class name */
  className: _propTypes["default"].string,

  /** Do not use in conjunction with value prop */
  defaultValue: _propTypes["default"].string,
  hasError: _propTypes["default"].bool,
  inputRef: _propTypes["default"].func,

  /** If the textarea is disabled */
  isDisabled: _propTypes["default"].bool,

  /** If the textarea is read-only */
  isReadOnly: _propTypes["default"].bool,

  /** Indicates the maximum height of the textarea  */
  maxHeight: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  size: _propTypes["default"].oneOf(_customPropTypes.ShirtSizes.DEFAULT),

  /** Do not use in conjunction with defaultValue prop */
  value: _propTypes["default"].string
};
var defaultProps = {
  a11yText: null,
  canExpand: true,
  className: null,
  defaultValue: "",
  hasError: false,
  inputRef: function inputRef() {},
  isDisabled: false,
  isReadOnly: false,
  maxHeight: "300px",
  onChange: function onChange() {},
  size: _customPropTypes.ShirtSizes.MEDIUM,
  value: null
};

var _StyledDiv = (0, _styledComponents["default"])("div").withConfig({
  displayName: "Textarea___StyledDiv",
  componentId: "sc-186fqpb-0"
})(["", ""], _Textarea["default"]);

function Textarea(props) {
  var textareaRef = _react["default"].useRef(null);

  var resize = function resize() {
    if (textareaRef.current && textareaRef.current.style) {
      textareaRef.current.style.height = 0;
      textareaRef.current.style.height = "".concat(textareaRef.current.scrollHeight + 2, "px");
    }
  };

  var a11yText = props.a11yText,
      className = props.className,
      canExpand = props.canExpand,
      hasError = props.hasError,
      inputRef = props.inputRef,
      isDisabled = props.isDisabled,
      onChange = props.onChange,
      isReadOnly = props.isReadOnly,
      maxHeight = props.maxHeight,
      size = props.size,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["a11yText", "className", "canExpand", "hasError", "inputRef", "isDisabled", "onChange", "isReadOnly", "maxHeight", "size"]);

  _react["default"].useEffect(function () {
    if (canExpand) {
      resize();
      window.addEventListener("resize", resize);
    }

    return function cleanup() {
      window.removeEventListener("resize", resize);
    };
  }, []);

  _react["default"].useEffect(function () {
    if (canExpand) {
      resize();
    }
  }, [canExpand]);

  var setRef = function setRef(node) {
    textareaRef.current = node;
    inputRef(node);
  };

  if (moreProps.value) {
    delete moreProps.defaultValue;
  } else {
    delete moreProps.value;
  }

  var handleChange = function handleChange(e) {
    if (canExpand) {
      resize();
    }

    onChange(e);
  };

  if (a11yText) moreProps["aria-label"] = a11yText;
  var rootClasses = (0, _classnames["default"])("form-textarea", "form-textarea--".concat(size), {
    "form-textarea--is-disabled": isDisabled
  }, {
    "form-textarea--is-readonly": isReadOnly
  }, {
    "form-textarea--has-error": hasError
  }, className);
  return /*#__PURE__*/_react["default"].createElement(_StyledDiv, {
    className: rootClasses
  }, /*#__PURE__*/_react["default"].createElement("textarea", (0, _extends2["default"])({
    "aria-invalid": hasError,
    className: "form-textarea__textarea",
    "data-pka-anchor": "textarea",
    disabled: isDisabled,
    readOnly: isReadOnly,
    onChange: handleChange,
    ref: setRef,
    style: {
      maxHeight: maxHeight
    }
  }, moreProps)));
}

Textarea.displayName = "Textarea";
Textarea.propTypes = propTypes;
Textarea.defaultProps = defaultProps;
var _default = Textarea;
exports["default"] = _default;
//# sourceMappingURL=Textarea.js.map